<div class="flex container">
  <div class="flex one">
    <div class="flex half-1" style="position: relative;">
      <img src={{MileleLogoPath}} class="milele-logo" alt="logo" (click)="navHome()" />
      <div class="flex power-small"> {{ powerdByText }} </div>
    </div>
    <div class="flex half-2"></div>
  </div>
  
  <div class="flex two">
    <img src={{logoPath}} class="logo" alt="logo" />
  </div>

  <div class="flex content-holder">
    <div class="flex content-wrapper">
      <div class="content">
        <div class="subcontent">
          <div class="formal">
            <h1 class="blue" style="margin-top: 40px;">Select Region</h1>
            <p class="lead local">
              Before proceeding, please let us know where you currently living
            </p>
              <div class="row settlor" style="display: flex; align-items: center; justify-content: center; margin-top: 10px;">
                <app-radios style="display: flex; width: 100%; align-items: center; justify-content: center;"
                  labelOptionA="I live in Kenya"
                  labelOptionB="I live outside Kenya"
                  (valueChange)="onRegionChange($event)" >
                </app-radios>
              </div>
          </div>
          <!-- BOTTOM OF FORM  iSwear.value === true -->
          <app-form-bottom style="width: 100%;"
            [text]="'Next'"
            [formValid]="true"
            [showContinue]="'false'"
            [buttonClickHandler]="submitRegionSelection.bind(this)">
          </app-form-bottom>
        </div>
      </div>
    </div>
  </div>
</div>
